import {createAction, props} from '@ngrx/store';


export class AppNavigationActions {

  private static readonly prefix = '[App Navigation] ';

  public static enableButton = createAction(
    this.prefix + 'Enable Button.',
    props<{ buttonId: string }>()
  );

  public static disableButton = createAction(
    this.prefix + 'Disable Button.',
    props<{ buttonId: string }>()
  );

  public static setButtonEnabled = createAction(
    this.prefix + 'Set Button Enabled.',
    props<{ buttonId: string; enabled: boolean }>()
  );

  public static setAllButtonsEnabled = createAction(
    this.prefix + 'Set All Buttons Enabled.',
    props<{ enabled: boolean }>()
  );

}
